(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[407],{

/***/ 64329:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-studies",
      function () {
        return __webpack_require__(68563);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CaseStudies": function() { return /* binding */ CaseStudies; },
  "default": function() { return /* binding */ case_studies; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/hooks/use-update-header.tsx
var use_update_header = __webpack_require__(41898);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/utils/constants.ts + 14 modules
var constants = __webpack_require__(68579);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/hooks/use-clean-header.tsx
var use_clean_header = __webpack_require__(90573);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/seo/index.tsx
var seo = __webpack_require__(25352);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/icons/case-studies-graphic.svg
var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgCaseStudiesGraphic = function SvgCaseStudiesGraphic(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 449,
    height: 750,
    viewBox: "0 0 449 750",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M57.4904 708L204.722 42H391.51L244.301 708H57.4904Z",
    stroke: "#1D2131",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M106.481 669L234.296 81H342.519L214.724 669H106.481Z",
    stroke: "#1D2131",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M153.482 617L258.787 133L295.518 133L190.23 617L153.482 617Z",
    stroke: "#1D2131",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M2.49211 748L167.927 2H446.508L281.098 748H2.49211Z",
    stroke: "#1D2131",
    strokeWidth: 4
  })));
};
var ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgCaseStudiesGraphic);

/* harmony default export */ var case_studies_graphic = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQ5IiBoZWlnaHQ9Ijc1MCIgdmlld0JveD0iMCAwIDQ0OSA3NTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01Ny40OTA0IDcwOEwyMDQuNzIyIDQySDM5MS41MUwyNDQuMzAxIDcwOEg1Ny40OTA0WiIgc3Ryb2tlPSIjMUQyMTMxIiBzdHJva2Utd2lkdGg9IjQiLz4KPHBhdGggZD0iTTEwNi40ODEgNjY5TDIzNC4yOTYgODFIMzQyLjUxOUwyMTQuNzI0IDY2OUgxMDYuNDgxWiIgc3Ryb2tlPSIjMUQyMTMxIiBzdHJva2Utd2lkdGg9IjQiLz4KPHBhdGggZD0iTTE1My40ODIgNjE3TDI1OC43ODcgMTMzTDI5NS41MTggMTMzTDE5MC4yMyA2MTdMMTUzLjQ4MiA2MTdaIiBzdHJva2U9IiMxRDIxMzEiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBkPSJNMi40OTIxMSA3NDhMMTY3LjkyNyAySDQ0Ni41MDhMMjgxLjA5OCA3NDhIMi40OTIxMVoiIHN0cm9rZT0iIzFEMjEzMSIgc3Ryb2tlLXdpZHRoPSI0Ii8+Cjwvc3ZnPgo=");
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/case-studies/hero-section/index.module.scss
var index_module = __webpack_require__(82144);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/case-studies/hero-section/index.tsx





const CaseStudiesHero = /*#__PURE__*/ (0,react.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (index_module_default())["section-wrapper"],
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (index_module_default())["section-content"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: (index_module_default()).title,
                            children: "Case studies"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: (index_module_default()).description,
                            children: [
                                "We can make an ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (index_module_default()).highlight,
                                    children: "extraordinary future"
                                }),
                                " happen together"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (index_module_default())["additional-info"],
                            children: "Learn how Olby has helped companies scale their tech teams and achieve their business goals."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default())["image-wrapper"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (index_module_default())["image-container"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "https://platform-statics.olby.com/case-studies.png",
                                fill: true,
                                sizes: "(max-width: 703px) 28.5rem, (max-width: 1279px) 37.2rem, 52.4rem",
                                className: (index_module_default()).image,
                                alt: "Man and woman look the camera smiling"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardRef, {
                            className: (index_module_default()).icon
                        })
                    ]
                })
            ]
        })
    });
});

// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/button/button.tsx
var button_button = __webpack_require__(79544);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs + 1 modules
var use_animation = __webpack_require__(75536);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/LazyMotion/index.mjs
var LazyMotion = __webpack_require__(35463);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/features-animation.mjs + 35 modules
var features_animation = __webpack_require__(72834);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 27 modules
var motion_minimal = __webpack_require__(97474);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/case-studies/case-cards-section/case-study-card/results-image.png
/* harmony default export */ var results_image = ({"src":"/_next/static/media/results-image.04952321.png","height":424,"width":699,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAALVBMVEX+/v76///w8fP3+fpdXIH44emkobb2xdTf4Ob10Nz/vdCZWYJya43n5Oo/PmqmdbK8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVQImQXBiQEAIAgDsStF8d9/XBNeZubpmz4GhBbT145oTEkYaKpSmA8S8gCwrakoYwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/case-studies/case-cards-section/case-study-card/styles.module.scss
var styles_module = __webpack_require__(59346);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/case-studies/case-cards-section/case-study-card/card-chip/styles.module.scss
var card_chip_styles_module = __webpack_require__(17779);
var card_chip_styles_module_default = /*#__PURE__*/__webpack_require__.n(card_chip_styles_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/case-studies/case-cards-section/case-study-card/card-chip/index.tsx



const CardChip = (param)=>{
    let { content , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((card_chip_styles_module_default())["card-chip-container"], className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            className: (card_chip_styles_module_default())["card-chip-content"],
            children: [
                "#",
                content
            ]
        })
    });
};
/* harmony default export */ var card_chip = (CardChip);

;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/case-studies/case-cards-section/case-study-card/index.tsx









const CONTENT_VARIANTS = {
    start: {
        y: "30%"
    },
    end: {
        y: "0%",
        transition: {
            type: "spring",
            bounce: 0
        }
    }
};
const CaseStudyCard = (param)=>{
    let { companyName , caseResume , href , badgeList , className , image  } = param;
    const contentControl = (0,use_animation/* useAnimation */._)();
    const onViewportEnter = (0,react.useCallback)(async ()=>{
        contentControl.start("end");
    }, [
        contentControl
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotion/* LazyMotion */.X, {
        features: features_animation/* domAnimation */.H,
        strict: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion_minimal.m.article, {
            onViewportEnter: onViewportEnter,
            variants: CONTENT_VARIANTS,
            initial: "start",
            viewport: {
                once: true,
                amount: 0.01
            },
            animate: contentControl,
            className: classnames_default()((styles_module_default())["case-study-card"], className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default())["case-study-card-content"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (styles_module_default()).title,
                            children: companyName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default())["card-chips-container"],
                            children: badgeList.map((badge)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(card_chip, {
                                    content: badge
                                }, badge))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (styles_module_default()).description,
                            children: caseResume
                        }),
                        href && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.zx, {
                            variant: "primary",
                            size: "large",
                            href: href,
                            className: (styles_module_default())["read-more-button"],
                            prefetch: false,
                            children: "Read more"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default())["image-wrapper"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image || results_image,
                        alt: "Case studies card",
                        fill: true,
                        sizes: "(max-width: 1279px) 100vw, 69.9rem",
                        className: (styles_module_default()).image
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var case_study_card = ((/* unused pure expression or super */ null && (CaseStudyCard)));

// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/case-studies/case-cards-section/styles.module.scss
var case_cards_section_styles_module = __webpack_require__(72328);
var case_cards_section_styles_module_default = /*#__PURE__*/__webpack_require__.n(case_cards_section_styles_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/case-studies/case-cards-section/index.tsx





const CASE_STUDIES = [
    {
        companyName: "Hapana",
        caseResume: "Hapana is the only end-to-end software solution built to deliver engagement and growth for ambitious fitness businesses. Proudly founded in Sydney Australia, Hapana delights over a million members in more than 10 countries and is trusted by brands such as BFT, UFC Gym, Gold’s Gym, KX Pilates, LTYB, GoYoga, Vive Active, and many more. Since 2019 Olby extends Hapana's engineering and design teams and helps making sure their products scale globally.",
        badgeList: [
            "fitness",
            "crm"
        ],
        href: "/blog/case-studies/hapana",
        imageHref: "https://platform-statics.olby.com/case-studies/hapana.png"
    },
    {
        companyName: "Benepass",
        caseResume: "Benepass is a growing startup headquartered in the Greater New York Area and baked by investors like Y-Combinator, GFC, Gradient Ventures, and more. They help companies take care of their people by providing a platform to distribute benefits and non-salary compensation globally flexibly. Olby has worked with them since 2021, helping to source, vet, hire, onboard and retain their team in Brazil from the ground up.",
        badgeList: [
            "employee benefits",
            "fintech"
        ],
        href: "/blog/case-studies/benepass",
        imageHref: "https://platform-statics.olby.com/case-studies/benepass.png"
    },
    {
        companyName: "Pythonic",
        caseResume: "Pythonic Corporation specializes in developing and applying advanced natural language and computer vision models, primarily focusing on the title insurance industry. Recognizing the unique needs of Pythonic`s tech division, Olby sourced and selected highly skilled software developers - a precise match of skills and culture that laid a solid foundation for Pythonic`s global team.",
        badgeList: [
            "artificial intelligence",
            "machine learning"
        ],
        href: "/blog/case-studies/pythonic",
        imageHref: "https://platform-statics.olby.com/case-studies/pythonic.png"
    },
    {
        companyName: "Dvora Life",
        caseResume: "  Dvora Life is a Real Estate company that showcases a portfolio of over 20 luxury properties across New Jersey and New York. Their platform provides a complete residential experience for members in multifamily buildings and offers property management tools for landlords. With a global vision for hiring and expansion, Dvora Life partnered with Olby to enhance their Engineering team, transforming their innovative concepts into great digital products.",
        badgeList: [
            "real estate",
            "leasing",
            "property management"
        ],
        href: "/blog/case-studies/dvora",
        imageHref: "https://platform-statics.olby.com/case-studies/dvora.png"
    },
    {
        companyName: "ShareThis",
        caseResume: "ShareThis Inc., is a technology company headquartered in Palo Alto, CA, with offices in New York, Chicago, and Los Angeles. It offers tools that allows sharing of content across 40+ social channels and are used by over three million publishers globally. Since 2019 Olby has been helping ShareThis scaling their tech teams to deliver new products faster.",
        badgeList: [
            "advertising",
            "analytics",
            "social media"
        ],
        href: "/blog/case-studies/share-this",
        imageHref: "https://platform-statics.olby.com/case-studies/sharethis.png"
    },
    {
        companyName: "SwingDev",
        caseResume: "SwingDev is a software development consultancy from California that helps promising companies grow. They partner with firms worldwide to build incredible products, giving them a cornerstone for commercial success. For nearly a decade, SwingDev has been providing the highest quality services for tech companies at different stages – from high-growth startups to Fortune 500 enterprises – by helping them with engineering, product design, and development.",
        badgeList: [
            "consulting",
            "development",
            "design"
        ],
        href: "/blog/case-studies/swing-dev",
        imageHref: "https://platform-statics.olby.com/case-studies/swingdev.png"
    },
    {
        companyName: "Loadsmart",
        caseResume: "Loadsmart is a leading freight technology company from Chicago, Illinois. The platform enables shippers, carriers, and brokers to efficiently manage an automated supply chain. In 2022 Loadsmart announced it had closed a $200 million Series D round led by SoftBank Latin America Fund, which values the company at $1.3 billion. Olby talent joined Loadsmart in 2021, scaling their teams and helping to create technologies that are becoming the new industry standard.",
        badgeList: [
            "logistics",
            "transportation"
        ],
        // TODO: add link when we have the blog post
        // href: '/',
        imageHref: "https://platform-statics.olby.com/case-studies/loadsmart.png"
    },
    {
        companyName: "Great Big Events",
        caseResume: "Great Big Events is an international Sport Presentation and Event Management company with offices in Sydney Australia, London United Kingdom and Doha Qatar with satellite offices around North America, Europe, Gulf Region and Australasia. Among its many notable sporting events, the company has produced the Sydney 2000, Beijing 2008, and London 2012 Olympic and Paralympic Games. Since 2018 Olby provides tech talent for GBE's innovation division with multiple products launch at scale.",
        badgeList: [
            "events",
            "sports"
        ],
        // TODO: add link when we have the blog post
        // href: '/',
        imageHref: "https://platform-statics.olby.com/case-studies/gbe.png"
    }
];
const CaseCardsSection = /*#__PURE__*/ (0,react.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (case_cards_section_styles_module_default())["case-studies-section"],
        ref: ref,
        children: CASE_STUDIES.map((caseStudy, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CaseStudyCard, {
                className: classnames_default()((case_cards_section_styles_module_default())["case-study-card"], {
                    [(case_cards_section_styles_module_default())["right-aligned"]]: index % 2 !== 0
                }),
                companyName: caseStudy.companyName,
                caseResume: caseStudy.caseResume,
                badgeList: caseStudy.badgeList,
                href: caseStudy.href,
                image: caseStudy.imageHref
            }, caseStudy.companyName))
    });
});
/* harmony default export */ var case_cards_section = ((/* unused pure expression or super */ null && (CaseCardsSection)));

// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/hire-olby-section/index.tsx + 3 modules
var hire_olby_section = __webpack_require__(85897);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/layouts/website-layout/index.tsx + 9 modules
var website_layout = __webpack_require__(46087);
;// CONCATENATED MODULE: ./pages/case-studies/index.tsx



const SEO = {
    title: "Case studies // Olby",
    description: "Learn how Olby helped companies to scale their tech teams and achieve business goals: we can make an extraordinary future happen together."
};
const CaseStudies = ()=>{
    const caseStudiesRef = (0,react.useRef)(null);
    const caseCardsRef = (0,react.useRef)(null);
    const hireOlbyRef = (0,react.useRef)(null);
    (0,use_update_header/* useUpdateHeader */.G)(caseStudiesRef, constants/* HEADER_THEMES.EXT_BRAND_TEAL_ALT */._.EXT_BRAND_TEAL_ALT);
    (0,use_update_header/* useUpdateHeader */.G)(caseCardsRef, constants/* HEADER_THEMES.NEUTRAL_BACKGROUND */._.NEUTRAL_BACKGROUND);
    (0,use_update_header/* useUpdateHeader */.G)(hireOlbyRef, constants/* HEADER_THEMES.EXT_DEEP_BLUE */._.EXT_DEEP_BLUE);
    (0,use_clean_header/* useCleanHeader */._)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* WebsiteSeo */.P, {
                seo: SEO
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseStudiesHero, {
                ref: caseStudiesRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseCardsSection, {
                ref: caseCardsRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hire_olby_section/* HireOlbySection */.K, {
                ref: hireOlbyRef
            })
        ]
    });
};
/* harmony default export */ var case_studies = (CaseStudies);
CaseStudies.getLayout = (page)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(website_layout/* WebsiteLayout */.CG, {
        shouldChangeBgColor: true,
        headerInitialTheme: constants/* HEADER_THEMES.EXT_BRAND_TEAL_ALT */._.EXT_BRAND_TEAL_ALT,
        children: page
    });
};


/***/ }),

/***/ 25352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ WebsiteSeo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55351);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



const WebsiteSeo = (param)=>{
    let { seo  } = param;
    const websiteUrl = "https://olby.com";
    const { asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const asPathWithoutParams = asPath.split("?")[0];
    const canonical = websiteUrl + asPathWithoutParams;
    const websiteSeo = {
        canonical,
        ...seo
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        ...websiteSeo
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WebsiteSeo);


/***/ }),

/***/ 17779:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-chip-container":"styles_card-chip-container__5tX2I","theme--light":"styles_theme--light__iEFFj","theme--dark":"styles_theme--dark__9tt4W","card-chip-content":"styles_card-chip-content__EIfTQ","fade-in-up":"styles_fade-in-up__3AyBN","fade-in-opacity":"styles_fade-in-opacity__XnRzr","fade-in-up-opacity":"styles_fade-in-up-opacity__I0V2_","fade-out-opacity":"styles_fade-out-opacity__HVmVI","fade-out-left":"styles_fade-out-left__RZH2d"};

/***/ }),

/***/ 59346:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"case-study-card":"styles_case-study-card__QqZ5J","case-study-card-content":"styles_case-study-card-content__BsMmj","title":"styles_title__2Qe3N","theme--light":"styles_theme--light__IhzQs","theme--dark":"styles_theme--dark__ym3B9","card-chips-container":"styles_card-chips-container__HWQBE","description":"styles_description__3fC8X","read-more-button":"styles_read-more-button__sbHTJ","image-wrapper":"styles_image-wrapper__BN3Zx","image":"styles_image__B504p","fade-in-up":"styles_fade-in-up__KqL5m","fade-in-opacity":"styles_fade-in-opacity__QBNvn","fade-in-up-opacity":"styles_fade-in-up-opacity__M6RKW","fade-out-opacity":"styles_fade-out-opacity___OJri","fade-out-left":"styles_fade-out-left__sfSKS"};

/***/ }),

/***/ 72328:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"case-studies-section":"styles_case-studies-section__bZr6U","case-study-card":"styles_case-study-card__tM0fg","right-aligned":"styles_right-aligned__NTUK0","fade-in-up":"styles_fade-in-up__lDoRH","fade-in-opacity":"styles_fade-in-opacity__Vlom6","fade-in-up-opacity":"styles_fade-in-up-opacity__qWEla","fade-out-opacity":"styles_fade-out-opacity__pRd3c","fade-out-left":"styles_fade-out-left__Cgs28"};

/***/ }),

/***/ 82144:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section-wrapper":"hero-section_section-wrapper__xO1nB","theme--light":"hero-section_theme--light__2xDKb","theme--dark":"hero-section_theme--dark__V62bB","section-content":"hero-section_section-content__2_Cb5","content":"hero-section_content__3QSY6","title":"hero-section_title__ZyKQd","description":"hero-section_description__FkEIb","highlight":"hero-section_highlight__PtrPj","additional-info":"hero-section_additional-info__ejHUM","image-wrapper":"hero-section_image-wrapper__17NYq","image-container":"hero-section_image-container__T26tn","image":"hero-section_image__MEUCT","icon":"hero-section_icon__0v7n8","fade-in-up":"hero-section_fade-in-up__SYsT0","fade-in-opacity":"hero-section_fade-in-opacity__4z07F","fade-in-up-opacity":"hero-section_fade-in-up-opacity__Pl2_D","fade-out-opacity":"hero-section_fade-out-opacity__I4mAD","fade-out-left":"hero-section_fade-out-left__If5C4"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [350,82,577,934,559,897,774,888,179], function() { return __webpack_exec__(64329); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);